const { Component } = wp.element;

class ErrorBoundary extends Component {
	constructor( props ) {
		super( props );
		this.state = { has_error: false };
	}

	static get_derived_state_from_error() {
		return { has_error: true };
	}

	render() {
		if ( this.state.has_error ) {
			return window.wp.i18n.__( 'Something went wrong. Please try again later.', 'ac-product-lookup' );
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
